import React, { useEffect, useState } from "react";
import axios from "axios";
import AppLayout from "@/components/AppLayout";
import { Trophy, Timer, Flag } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Leaderboard() {
  const [data, setData] = useState({ fastest_wins: [], top_racers: [] });

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/leaderboard`).then((r) => setData(r.data));
  }, []);

  const fmtTime = (s) => {
    if (!s && s !== 0) return "—";
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  };

  return (
    <AppLayout>
      <div className="px-6 lg:px-12 py-10">
        <div className="label-kicker">Glory board</div>
        <h1 className="font-heading text-5xl lg:text-6xl mt-1">Rankings</h1>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="surface-solid p-6">
            <div className="flex items-center gap-2 mb-5">
              <Trophy className="w-4 h-4 text-[#FFCC00]" />
              <div className="label-kicker">Top racers</div>
            </div>
            {data.top_racers.length === 0 && (
              <div className="text-sm text-white/50 py-6 text-center">Be the first to climb.</div>
            )}
            <div className="space-y-2" data-testid="leaderboard-top-racers">
              {data.top_racers.map((u, i) => (
                <div
                  key={u.user_id}
                  data-testid={`leaderboard-racer-${i}`}
                  className="flex items-center gap-3 border border-white/10 p-3"
                >
                  <div className="font-heading text-2xl text-[#FF3B30] w-8">{i + 1}</div>
                  {u.picture ? (
                    <img src={u.picture} alt={u.name} className="w-10 h-10 rounded-full border border-white/15" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-[#FF3B30]/60 flex items-center justify-center text-black font-bold">
                      {u.name?.[0]?.toUpperCase()}
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="font-heading truncate">{u.name}</div>
                    <div className="text-xs text-white/50 font-mono">
                      {u.competitive_wins ?? 0} COMP WINS · {u.races} RACES
                    </div>
                  </div>
                  <div className="text-[#FFCC00] font-mono text-sm">{u.currency.toLocaleString()} ₡</div>
                </div>
              ))}
            </div>
          </div>

          <div className="surface-solid p-6">
            <div className="flex items-center gap-2 mb-5">
              <Timer className="w-4 h-4 text-[#FF3B30]" />
              <div className="label-kicker">Fastest clears</div>
            </div>
            {data.fastest_wins.length === 0 && (
              <div className="text-sm text-white/50 py-6 text-center">Win a race to set a time.</div>
            )}
            <div className="space-y-2" data-testid="leaderboard-fastest">
              {data.fastest_wins.map((r, i) => (
                <div key={r.result_id} className="flex items-center gap-3 border border-white/10 p-3">
                  <div className="font-heading text-2xl text-[#FFCC00] w-8">{i + 1}</div>
                  <div className="flex-1">
                    <div className="font-heading">{r.name}</div>
                    <div className="text-xs text-white/50 font-mono flex items-center gap-1">
                      <Flag className="w-3 h-3" /> {r.city_name}
                    </div>
                  </div>
                  <div className="font-mono text-[#FF3B30]">{fmtTime(r.time_seconds)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
